<template>
    <div>
        <ul class="nav nav-pills" role="tablist" id="psp">
            <li class="nav-item mb-2" :key="psp_name" v-for="(value, psp_name) in psp_list">
                <a :class="{ 'nav-link' : true, 'active': activeTab(psp_name) }"
                   data-toggle="tab" :href="'#' + psp_name" role="tab" aria-selected="false"
                   @click="changeTab(psp_name)" :id="'tab_' + psp_name"
                >
                    {{ $t('psp.' + psp_name) }}
                </a>
            </li>
        </ul>
        <div class="tab-content" :key="psp_name" v-for="(value, psp_name) in psp_list">
            <div :class="{ 'tab-pane': true, 'active' : activeTab(psp_name) }" :id="'#' + psp_name">
                <psp-details v-if="shop_psp_requests_status === 'success' && shop_shaparak_requests_status === 'success'"/>
            </div>
        </div>
    </div>
</template>

<script>
    import pspDetails from "./pspDetails";
    import {mapGetters} from "vuex";

    export default {
        components: {
            pspDetails
        },
        props: {
            psp_list: {
                required: true,
                type: Object
            }
        },
        computed: {
            ...mapGetters('pspRequest', [
                'shop_psp_requests_status',
                'shop_psp_requests',
                'psp_requests',
                'current_psp_tab',
            ]),
            ...mapGetters('shaparak', [
                'shop_shaparak_requests_status',
                'shop_shaparak_requests'
            ]),
        },
        data() {
            return {
                active_pane: Object.keys(this.psp_list)[0],
                currentTab: 1,
            }
        },
        methods: {
            activeTab(psp_name) {
                return this.active_pane === psp_name
            },
            changeTab(psp_name) {
                this.$store.commit('pspRequest/setCurrentPspTab', psp_name)
                this.$store.commit('pspRequest/setPspRequests', this.shop_psp_requests[psp_name])
                this.$store.commit('shaparak/setShaparakRequests', this.shop_shaparak_requests[psp_name])
            }
        },
        mounted() {
            this.$store.commit('pspRequest/setCurrentPspTab', this.active_pane)
            this.$store.commit('pspRequest/setPspRequests', this.shop_psp_requests[this.active_pane])
            this.$store.commit('shaparak/setShaparakRequests', this.shop_shaparak_requests[this.active_pane])
        }
    }
</script>

<style scoped>
    #psp {
        border-bottom: 1px solid #ebedf2;
        padding-bottom: 1px;
    }
</style>